module.exports = __webpack_public_path__ + "img/course_bg03.03e5cd95.png";